import { gql } from "@apollo/client";

export const GET_COSTALEROS = gql`
query GetCostaleros($cuadrilla: Int!) {
  getCostaleros(cuadrilla: $cuadrilla) {
    id
    name
  }
}
`